import loadable, { lazy } from '@loadable/component';
import { createContext } from '@shared/utils/createContext';

interface ViewContext {
  changeView: (view: SupportedView) => void;
  currentView: SupportedView;
}

const SignIn = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/signIn" */
      '@apps/createWedding/routes/SignIn/SignIn'
    ),
);

const CreateAccount = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/createAccount" */
      '@apps/createWedding/routes/CreateAccount/CreateAccount'
    ),
);

const CreateWeddingForm = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/createWeddingForm" */
      '@apps/createWedding/routes/CreateWeddingForm/CreateWeddingForm'
    ),
);

const SocialAccount = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/socialAccount" */
      '@apps/createWedding/routes/SocialAccount/SocialAccount'
    ),
);

const WeddingAlreadyExists = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/weddingAlreadyExists" */
      '@apps/createWedding/routes/WeddingAlreadyExists/WeddingAlreadyExists'
    ),
);

const ForgotPassword = lazy(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/forgotPassword" */
      '@apps/createWedding/routes/ForgotPassword/ForgotPassword'
    ),
);

const Survey = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/survey" */
      '@apps/createWedding/routes/Survey/Survey'
    ),
);

export const viewMap = {
  createAccount: CreateAccount,
  socialAccount: SocialAccount,
  createWeddingForm: CreateWeddingForm,
  questionnaire: Survey,
  weddingAlreadyExists: WeddingAlreadyExists,
  forgotPassword: ForgotPassword,
  signIn: SignIn,
};

export type SupportedView = keyof typeof viewMap;

const [ViewProvider, useViewContext] = createContext<ViewContext>({ name: 'ViewContext' });

export { ViewProvider, useViewContext };
